import React from "react";

const Error = () => {
  return <div>404</div>;
};

export default Error;
